// Import Styles
import './sass/index.scss';
import './styles/index.css';

// Import Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';

// Import UseEffect
import { useEffect , useState} from 'react';

import { AuthProvider, useAuth } from "./components/context/AuthContext";

// Import Components
import TopInfoBar from './components/TopInfoBar';
import Navbar from './components/Navbar';
import Cover from './components/Cover';
import Advantages from './components/Advantages';
import AboutUs from './components/AboutUs';
import Services from './components/Services';
import Location from './components/Location';
import Team from './components/Team';
import Contact from './components/Contact';
import Faq from './components/Faq';
import UpButton from './components/UpButton';
import WhatsappButton from './components/WhatsappButton';
import Footer from './components/Footer';

// Import Atropos
import 'atropos/css'

// App Component
function App() {

  useEffect(() => {
    window.scrollTo(0, 0); 
  }, []);

  const [openCarousel, setOpenCarousel] = useState(true);

  return (
      <div className="App">
        <TopInfoBar />
        <Navbar status={true}/>
        <Cover section='home' coverImg={true}/>
        <Advantages />
        <AboutUs />
        <Services />
        <UpButton />
        <WhatsappButton />
        <Location />
        <Team />
        <Faq />
        <Contact />
        <Footer/>
      </div>
  );
}

// Export App Component
export default App;
